import { render, staticRenderFns } from "./MainScreen.vue?vue&type=template&id=c9b93cda&scoped=true"
import script from "./MainScreen.vue?vue&type=script&lang=js"
export * from "./MainScreen.vue?vue&type=script&lang=js"
import style0 from "./MainScreen.vue?vue&type=style&index=0&id=c9b93cda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b93cda",
  null
  
)

export default component.exports